import React from "react";

export function WB_CustomLeadersGroupModerators({}) {
    return <div>
        WB_CustomLeadersGroupModerators
    </div>
}